/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CashBoxesStatisticsDto } from '../api/statistics/statisticsClient.typings';
import { StatisticsActions, StatisticsActionType } from '../actions/statisticsActions';

export interface StatisticsState {
    cashBoxStatistics: CashBoxesStatisticsDto;
    isLoadingCashBoxStatistics: boolean;
}

const initialState: StatisticsState = {
    cashBoxStatistics: null,
    isLoadingCashBoxStatistics: false,
};

function statisticsReducer(state: StatisticsState = initialState, action: StatisticsActions): StatisticsState {
    switch (action.type) {
        case StatisticsActionType.OPEN_STATISTICS_PAGE:
        case StatisticsActionType.FETCH_CASHBOX_STATISTICS:
            return {
                ...state,
                isLoadingCashBoxStatistics: true,
            };

        case StatisticsActionType.FETCH_CASHBOX_STATISTICS_SUCCESS:
            return {
                ...state,
                isLoadingCashBoxStatistics: false,
                cashBoxStatistics: action.payload,
            };

        case StatisticsActionType.FETCH_CASHBOX_STATISTICS_ERROR:
            return {
                ...state,
                isLoadingCashBoxStatistics: false,
            };

        case StatisticsActionType.EXIT_STATISTICS_PAGE:
            return {
                ...state,
                cashBoxStatistics: null,
            };

        default:
            return state;
    }
}

export default statisticsReducer;
